/**
 * Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import { apiRegistration } from "../../services/api";
import {
  COOKIE_NAME,
  COOKIE_QUERY_NAME,
  deleteCookie,
  gtmRegistration,
  POST_REG_FUNNEL_SHOW,
  POST_REG_FUNNEL_SHOW_REQUIRED,
  prepareRegistrationData,
  REGISTRATION_CONFIRMED,
  simplyClick,
} from "../../helpers";

/**
 *Styles
 */
import "./Result.scss";

const Result = () => {
  const { data } = useContext(ContextProfileUser);
  const [loader, setLoader] = useState(false);
  const [responseError, setResponseError] = useState(null);

  const postRegistrationRequest = () => {
    setLoader(true);
    if (data) {
      simplyClick("cl_lnd_am30_reg_conf_cont");
      apiRegistration(prepareRegistrationData(data), responseCb);
    }
  };

  const responseCb = (response) => {
    setLoader(false);
    if (response.status === 200) {
      const data = JSON.parse(response.responseText);

      if (data.success === true) {
        deleteCookie(COOKIE_QUERY_NAME);
        deleteCookie(COOKIE_NAME);
        gtmRegistration(data.data);

        if (data.data.onModeration === true) {
          window.location.href = "/moderation/";
        } else {
          if (
            data.data.confirmed === REGISTRATION_CONFIRMED &&
            data.data.access_token
          ) {
            if (
              data.data.reg_funnel_status === POST_REG_FUNNEL_SHOW ||
              data.data.reg_funnel_status === POST_REG_FUNNEL_SHOW_REQUIRED
            ) {
              window.location.href = "/wizard/";
            } else {
              window.location.href = "/app/";
            }
          } else {
            window.location.href = "/confirm/";
          }
        }
      }

      return;
    } else if (response.status === 422) {
      const data = JSON.parse(response.responseText);

      if (data.errors && data.errors.length > 0) {
        let errorText = "";

        for (let i = 0; i < data.errors.length; i++) {
          const error = data.errors[i];

          errorText += i > 0 ? " " + error.message : error.message;
        }

        setResponseError(errorText);
        return;
      }
    } else if (response.status === 403) {
      window.location.href = "/moderation/";
      return;
    }

    setResponseError(
      "Can't register your profile now. Please try again later."
    );
  };

  return (
    <>
      {loader && (
        <div className="spin-loader">
          <span>Loading...</span>
        </div>
      )}
      <div className="result__wrap">
        <h5 className="form__title">
          Congrats, you’re seconds away from meeting your match!
        </h5>
        <p className="global__text">
          Please share more about yourself in your profile, and remember to
          treat other members with respect.
        </p>
        <button onClick={postRegistrationRequest} className="submit">
          Set up your profile
        </button>
        {responseError && <p className="error-text">{responseError}</p>}
      </div>
    </>
  );
};
export default Result;
